import { useTranslations } from '@vocab/react';
import {
  Box,
  Text,
  Strong,
  IconHelp,
  TooltipRenderer,
  Inline,
} from 'braid-design-system';
import { memo, type ReactNode } from 'react';

import translations from './.vocab';

const JobCount = ({ count = 0 }: { count?: number }) => {
  const { t } = useTranslations(translations);
  return (
    <Inline
      space="xxsmall"
      data={{
        automation: 'jobCountContainer',
      }}
    >
      <Text>
        {t('{count} jobs recommended for you', {
          Strong: (children: ReactNode) => <Strong>{children}</Strong>,
          count: String(count),
        })}
      </Text>
      <TooltipRenderer
        id="how-it-works-tip"
        placement="bottom"
        tooltip={
          <Text size="small">
            {t('We recommend opportunities based on...')}
          </Text>
        }
      >
        {({ triggerProps }) => (
          <Box aria-label={t('Help')} {...triggerProps}>
            <Text icon={<IconHelp />} size="large" />
          </Box>
        )}
      </TooltipRenderer>
    </Inline>
  );
};

export default memo(JobCount);
